<template>
    <div>
        <internal-header v-if="!pdf_view" heading="Availability And Bookings"/>
        <availability-report-filters
            v-if="$vuetify.breakpoint.mdAndUp && !pdf_view"
            v-model="filters"
            :constants="constants"
            :valuelists="valuelists"
            />
        <v-expansion-panels v-else-if="!pdf_view" flat>
            <v-expansion-panel>
                <v-expansion-panel-header hide-actions>
                    <template v-slot:default="{ open }">
                        <v-container class="py-0">
                            <v-row no-gutters>
                                <v-col cols="11" class="tw-text-lg">Filters<span v-show="!!filters_used">: {{ filters_used }}</span></v-col>
                                <v-col cols="1">
                                    <v-icon>
                                        <template v-if="open">mdi-minus-circle</template>
                                        <template v-else>mdi-plus-circle</template>
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <availability-report-filters
                        v-model="filters"
                        :constants="constants"
                        :valuelists="valuelists"
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center tw-pt-2 tw-pb-1 tw-border-b tw-border-t tw-border-dark-grey">
            <div class="tw-text-xl tw-font-light" v-show="num_members_filtered">{{ num_members_filtered }} Listings</div>
<!--            <div v-if="!pdf_view" @click="exportAsExcel()" class="tw-text-black tw-underline tw-text-xs tw-font-normal tw-text-link tw-cursor-pointer">Export List</div>-->
            <div v-if="!pdf_view" @click="exportAsPdf()" class="tw-text-black tw-underline tw-text-xs tw-font-normal tw-text-link tw-cursor-pointer">Print List</div>
        </div>

        <smart-table
            ref="availability_list"
            endpoint="reports.list.availability"
            :pdf_endpoint="route('reports.availability.queue', 'pdf').url()"
            :items="items"
            item-key="comp_id"
            :hide-default-header="true"
            :hide-default-footer="pdf_view"
            :headers="headers"
            :search="filters.search"
            :group-by="['title_function_id']"
            :sort-desc="[false,false]"
            :multi-sort="true"
            :items-per-page="getDefaultItemsPerPage()"
            :footer-props="{
                'items-per-page-options': getDefaultItemsPerPageOptions()
            }"
            flat
            @fetch-complete="receivedRecordsUpdate"
            export_endpoint="reports.export.availability"
            export_endpoint_method="post"
            export_filename="availability-export.xls"
            id="availability_table"
        >

            <template v-slot:group.header="{items, isOpen, toggle}">
                <th :colspan="headers.length" @click="toggle">
                    {{ items[0].title_function_name }}
                </th>
            </template>

            <template v-slot:item.last_name="{ isMobile, item, header, value, index}">
                {{ getFullNameWithDesignation(item) }}
            </template>

            <template v-slot:item.mailing_address[0].city_and_province="{ isMobile, item, header, value, index}">
                <div>
                    <span style="">{{value}}</span>
                </div>
                <div v-if="item.billing_address && item.billing_address.length > 0 && !isAddressSame(item)">
                    {{ item.billing_address[0].city_and_province }}
                </div>
            </template>

            <template v-slot:item.telephones.telephone_fax="{ isMobile, item, header, value, index}">
                <span v-html="getPhoneHtml(item)"></span>
            </template>

            <template v-slot:item.emails.email="{ isMobile, item, header, value, index}">
                {{ getEmailDisplay(item) }}
            </template>

            <template v-slot:item.availability_info="{ isMobile, item, header, value, index}">
                {{ getAvailabilityWithMemo(item)  }}
            </template>

        </smart-table>

    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayout from "@/Layouts/AppLayout.vue";
    import AvailabilityReportFilters from "@/Pages/InternalPages/Reports/AvailabilityReportFilters.vue";
    import InternalHeader from "@/Generic/InternalHeader.vue";

    export default {
        name: "AvailabilityReport",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            InternalHeader,
            AvailabilityReportFilters,
            SmartTable,
        },
        remember: {
            data: [
                'items'
            ]
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'items': {          // Will optionally accept a hardcoded list of items instead of getting smart table to fetch them
                type: Array,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'pdf_view': {          // Indicates if this instance is a PDF view
                type: Boolean,
                required: false,
                default: function () {
                    return false
                }
            },
        },
        data() {
            return {
                constant: this.constants,
                filters: {
                    search: null,
                    region: undefined,
                    category: undefined,
                    skill: undefined,
                    province: undefined,
                },
                fetch_data_response: null,
                items_local: this.items || null,
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'last_name',                            text: 'Name',           align: `start`,                     sortable: true,    filterable: true,   },
                    {value: 'first_name',                           text: 'Name',           align: ` d-none`,                   sortable: true,    filterable: true,   },
                    {value: 'designation',                          text: 'Designation',    align: ` d-none`,                   sortable: true,    filterable: false,  },
                    {value: 'mailing_address[0].city_and_province', text: 'Location',       align: `start`,sortable: false,   filterable: false,  },
                    {value: 'billing_address[0].city_and_province', text: 'Billing',        align: ` d-none`,                   sortable: false,   filterable: false,  },
                    {value: 'title_function_priority',              text: 'Priority',       align: ` d-none`,                   sortable: true,    filterable: true,   },
                    {value: 'title_function_id',                    text: 'Category ID',    align: ` d-none`,                   sortable: true,    filterable: true,   },
                    {value: 'region',                               text: 'Region',         align: ` d-none`,                   sortable: false,   filterable: true,   search: this?.filters?.region   },
                    {value: 'report_telephones[0].telephone_fax',   text: 'Phone',          align: `start tw-whitespace-nowrap`,sortable: false,   filterable: false,  },
                    {value: 'emails.email',                         text: 'Email',          align: `start`,                     sortable: false,   filterable: false,  },
                    {value: 'availability_info',                    text: 'Availability',   align: `start`,                     sortable: false,   filterable: false,  },
                    {value: 'functions_active.title_function_id',   text: 'Categories',     align: ` d-none`,                   sortable: false,   filterable: true,   search: this?.filters?.category },
                    {value: 'member_addresses.province_id',         text: 'Province',       align: ` d-none`,                   sortable: false,   filterable: true,   search: this?.filters?.province },

                ]
            },
            filters_used() {
                let filters_used = Object.keys(this.filters).filter(filter => (!!this.filters[filter] && this.filters[filter].length))
                if (filters_used?.length === 4) return "All"
                if (!filters_used || filters_used.length === 0) return ""
                return filters_used?.join(", ").toProperCase()
            },
            num_members_total() {
                return this.fetch_data_response?.data?.recordsTotal
            },
            num_members_filtered() {
                return this.fetch_data_response?.data?.recordsFiltered || this.items?.length
            },
            values_regions() {
                if (this?.constants?.MEMBER_REGIONS) {
                    return Object.values(this.constants?.MEMBER_REGIONS)
                }
                return []
            },
            values_categories() {
                if (this?.valuelists?.TITLE_FUNCTIONS) {
                    return Object.values(this.valuelists?.TITLE_FUNCTIONS)
                }
                return []
            },
            values_skills() {
                if (this?.valuelists?.SKILLS_GROUPED) {
                    return Object.values(this.valuelists?.SKILLS_GROUPED)
                }
                return []
            },
        },
        methods: {
            example() {
                console.log("This is just a test")
            },
            getUsersMultiCategorized(items) {
                if (!items) {
                    return items
                }
                let multi_users = items?.flatMap(user => {
                        let new_entries = user?.functions_active?.map(title_function => ({
                            ...user,
                            id: `${user.id}.${title_function.title_function_id}`,
                            title_function_id: title_function.title_function_id,
                            title_function_name: title_function.title_function.name,
                            title_function_priority: title_function.title_function.priority,
                        }))
                        return new_entries.length ? new_entries : {...user, title_function_id: null}
                    }
                )
                // multi_users.sort(function(a,b) {
                //     if(a.title_function_priority !== b.title_function_priority && (!!a.title_function_priority) ) return (a.title_function_priority - b.title_function_priority);
                //     if(a.title_function_id !== b.title_function_id && (!!a.title_function_id)) return (a.title_function_id - b.title_function_id);
                //     return (a.last_name < b.last_name) ? -1 : 1;
                // })
                return multi_users
            },
            receivedRecordsUpdate(response) {
                this.fetch_data_response = response
                this.$set(this, 'items_local', this.$refs.availability_list.items_local)
            },
            getNameForDisplay(record) {
                if (!!record?.last_name && !!record?.first_name) {
                    return `${record.last_name}, ${record.first_name}`
                }
                return record?.last_name || record?.first_name
            },
            getFullNameWithDesignation(record) {
                if (!!record?.last_name && !!record?.first_name) {
                    return `${record.last_name}, ${record.first_name}` + ((record?.designation) ? `, ${record?.designation}` : '')
                }
                return record?.last_name || record?.first_name
            },
            getEmailDisplay(record) {
                return record?.emails?.find(email => !!email.email)?.email
            },
            getAvailabilityWithMemo(record){
                let availability_memo = (record?.availability_memo !== null) ? ' - ' + record?.availability_memo : '';
                return record?.availability_info + availability_memo;
            },
            getPhoneDisplay(record) {
                let phone = record?.telephones?.filter(phone => phone.include_in_report)?.find(phone => phone.telephone_fax)?.telephone_fax
                return this.$root.formatPhoneDisplay(phone)
            },
            getPhoneHtml(record) {
                let phone = record?.telephones?.filter(phone => phone.include_in_report)?.find(phone => phone.telephone_fax)?.telephone_fax
                if (!phone) {
                    return null
                }
                let phone_display = this.$root.formatPhoneDisplay(phone)
                let phone_digits = this.$root.formatPhoneNumeric(phone)
                return `<a href="tel:${phone_digits}">${phone_display}</a>`
            },
            getDefaultItemsPerPage() {
                return this.pdf_view ? -1 : 20
                // return -1
            },
            getDefaultItemsPerPageOptions() {
                return this.pdf_view ? [-1] : [5, 10, 20, 30]
                // return [-1]
            },
            async exportAsExcel() {
                await this.$refs.availability_list.getExport()
            },
            async exportAsPdf() {
                await this.$refs.availability_list.getPdf()
            },
            isAddressSame(item) {
                return item.mailing_address[0]?.city_and_province === item.billing_address[0]?.city_and_province
            },
        },

        watch: {
            items: {
                handler(newVal, oldVal) {
                    this.$set(this, 'items_local', newVal)
                },
                deep: true,
                immediate: true,
            },
        },
    }
</script>

<style>

@media print {
    .pagebreak {
        page-break-after: always;
        min-height: 1px;
    }

    html, body {
        font-size: 10pt; /* changing to 10pt has no impact */
        margin-top: -40px;
    }

    th {
        height: 24px !important; /* changing to 10pt has no impact */
    }

    #availability_table td {
        height: 12px !important; /* changing to 10pt has no impact */
        padding: 0 8px !important;
    }
}

.row-pointer tbody tr {
    cursor: pointer;
}

</style>
